import { useState } from "react";
import { FiChevronDown } from "react-icons/fi";
import { BRAZILIAN_STATES } from "./utils";

const inputClass =
  "individual-onboarding-input h-10 w-full rounded-lg border border-gray-200 bg-white px-3 text-sm text-brand-dark outline-none transition focus:border-[#e7a73f] focus:ring-2 focus:ring-[#e7a73f]/20 dark:border-brand-dark-border dark:bg-brand-dark-surface dark:text-gray-100";

const labelClass = "mb-1 block text-xs font-medium text-gray-500 dark:text-gray-400";

const getAddressSummary = (address) => {
  const city = address.city?.trim();
  const state = address.state?.trim();
  if (city && state) return `${city}, ${state}`;
  if (city) return city;
  if (state) return state;
  return "Preencher endereço";
};

export const AddressFields = ({
  address,
  onChange,
  onZipCodeChange,
  cepLoading = false,
  cepError = false,
  idPrefix = "address",
  collapsible = false,
  collapsibleTitle = "Endereço",
  defaultExpanded = true,
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  const update = (field, value) => {
    onChange({ ...address, [field]: value });
  };

  const fields = (
    <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
      <label>
        <span className={labelClass}>CEP</span>
        <input
          id={`${idPrefix}-zip`}
          className={inputClass}
          value={address.zipCode}
          onChange={(e) => onZipCodeChange(e.target.value)}
          required
        />
        {cepLoading ? (
          <span className="mt-0.5 block text-xs text-gray-400">Buscando CEP…</span>
        ) : null}
        {!cepLoading && cepError ? (
          <span className="mt-0.5 block text-xs text-red-500">CEP não encontrado.</span>
        ) : null}
      </label>
      <label>
        <span className={labelClass}>Estado</span>
        <select
          className={inputClass}
          value={address.state}
          onChange={(e) => update("state", e.target.value)}
          required
        >
          <option value="">Selecione</option>
          {BRAZILIAN_STATES.map((uf) => (
            <option key={uf} value={uf}>
              {uf}
            </option>
          ))}
        </select>
      </label>
      <label>
        <span className={labelClass}>Número</span>
        <input
          className={inputClass}
          value={address.number}
          onChange={(e) => update("number", e.target.value)}
          required
        />
      </label>
      <label className="sm:col-span-2 lg:col-span-3">
        <span className={labelClass}>Rua</span>
        <input
          className={inputClass}
          value={address.street}
          onChange={(e) => update("street", e.target.value)}
          required
        />
      </label>
      <label>
        <span className={labelClass}>Complemento</span>
        <input
          className={inputClass}
          value={address.complement}
          onChange={(e) => update("complement", e.target.value)}
        />
      </label>
      <label>
        <span className={labelClass}>Bairro</span>
        <input
          className={inputClass}
          value={address.neighborhood}
          onChange={(e) => update("neighborhood", e.target.value)}
          required
        />
      </label>
      <label>
        <span className={labelClass}>Cidade</span>
        <input
          className={inputClass}
          value={address.city}
          onChange={(e) => update("city", e.target.value)}
          required
        />
      </label>
    </div>
  );

  if (!collapsible) {
    return fields;
  }

  const summary = getAddressSummary(address);

  return (
    <div className="individual-onboarding-address-collapse">
      <button
        type="button"
        className="individual-onboarding-address-collapse__trigger"
        aria-expanded={expanded}
        onClick={() => setExpanded((current) => !current)}
      >
        <FiChevronDown
          className={`h-3.5 w-3.5 shrink-0 text-gray-400 transition dark:text-gray-500 ${
            expanded ? "rotate-180 text-[#e7a73f] dark:text-brand-gold-mid" : ""
          }`}
          aria-hidden
        />
        <span className="text-xs font-semibold uppercase tracking-wide text-gray-400 dark:text-gray-500">
          {collapsibleTitle}
        </span>
        {!expanded ? (
          <span className="individual-onboarding-address-collapse__summary">{summary}</span>
        ) : null}
      </button>
      {expanded ? <div className="border-t border-gray-100 px-3 pb-3 pt-2 dark:border-brand-dark-border">{fields}</div> : null}
    </div>
  );
};
